
// Define department data with regions for better organization and SEO
export interface Department {
  code: string;
  name: string;
  region: "Occitanie" | "Île-de-France" | "Auvergne-Rhône-Alpes";
  coordinates: [number, number]; // [longitude, latitude]
}

export const departments: Department[] = [
  // Occitanie
  { code: "12", name: "Aveyron", region: "Occitanie", coordinates: [2.5731, 44.1764] },
  { code: "81", name: "Tarn", region: "Occitanie", coordinates: [2.1583, 43.7743] },
  { code: "46", name: "Lot", region: "Occitanie", coordinates: [1.6078, 44.6244] },
  { code: "82", name: "Tarn-et-Garonne", region: "Occitanie", coordinates: [1.3752, 44.0111] },
  { code: "31", name: "Haute-Garonne", region: "Occitanie", coordinates: [1.4442, 43.6047] },
  { code: "11", name: "Aude", region: "Occitanie", coordinates: [2.4153, 43.2114] },
  { code: "34", name: "Hérault", region: "Occitanie", coordinates: [3.4000, 43.5833] },
  { code: "30", name: "Gard", region: "Occitanie", coordinates: [4.3600, 44.1275] },
  
  // Auvergne-Rhône-Alpes
  { code: "15", name: "Cantal", region: "Auvergne-Rhône-Alpes", coordinates: [2.6650, 45.0511] },
  { code: "43", name: "Haute-Loire", region: "Auvergne-Rhône-Alpes", coordinates: [3.8830, 45.0428] },
  { code: "63", name: "Puy-de-Dôme", region: "Auvergne-Rhône-Alpes", coordinates: [3.0870, 45.7772] },
  
  // Île-de-France
  { code: "75", name: "Paris", region: "Île-de-France", coordinates: [2.3522, 48.8566] },
  { code: "77", name: "Seine-et-Marne", region: "Île-de-France", coordinates: [2.9600, 48.5734] },
  { code: "78", name: "Yvelines", region: "Île-de-France", coordinates: [1.8275, 48.8053] },
  { code: "91", name: "Essonne", region: "Île-de-France", coordinates: [2.2900, 48.5500] },
  { code: "92", name: "Hauts-de-Seine", region: "Île-de-France", coordinates: [2.2180, 48.8280] },
  { code: "93", name: "Seine-Saint-Denis", region: "Île-de-France", coordinates: [2.4836, 48.9136] },
  { code: "94", name: "Val-de-Marne", region: "Île-de-France", coordinates: [2.4530, 48.7909] },
  { code: "95", name: "Val-d'Oise", region: "Île-de-France", coordinates: [2.1000, 49.0592] },
];
